import { Box, Text } from "grommet";

import * as React from "react";
import { getTeam, TeamViewModel } from "./TeamsStore";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { useQuerySwitch } from "../general/Helpers";

export const TeamNameWrapper = () => {
    let { id } = useParams<{ id: string }>();
    const [team, setTeam] = React.useState({} as TeamViewModel);

    React.useEffect(() => {
        getTeam(id).then((response) => {
            setTeam(response.data.result);
            console.log("interactive");
        });
    }, []);

    const useTeamColor = useQuerySwitch("useTeamColor");

    return <TeamName team={team} size="large" color={useTeamColor ? team.color : ""}></TeamName>;
};

export const TeamLogoWrapper = () => {
    let { id } = useParams<{ id: string }>();
    const [team, setTeam] = React.useState({} as TeamViewModel);

    React.useEffect(() => {
        getTeam(id).then((response) => {
            setTeam(response.data.result);
            console.log("interactive");
        });
    }, []);

    return <img src={team.logoUri} width="60px" alt="" />;
};

export const TeamNameLogoWrapper = () => {
    let { id } = useParams<{ id: string }>();
    const [team, setTeam] = React.useState({} as TeamViewModel);

    React.useEffect(() => {
        getTeam(id).then((response) => {
            setTeam(response.data.result);
            console.log("interactive");
        });
    }, []);

    const reverse = useQuerySwitch("reVerse");
    const useTeamColor = useQuerySwitch("useTeamColor");

    return <TeamNameLogo reverse={reverse} team={team} useTeamColor={useTeamColor}></TeamNameLogo>;
};

export const TeamNameLogo = ({ reverse, team, useTeamColor }) => {
    if (reverse) {
        return (
            <>
                <Box direction="row" align="center" gap="small">
                    <TeamName team={team} size="large" color={useTeamColor ? team.color : ""}></TeamName>
                    <img src={team.logoUri} width="60px" alt="" />
                </Box>
            </>
        );
    } else {
        return (
            <>
                <Box direction="row" align="center" gap="small">
                    <img src={team.logoUri} width="60px" alt="" />
                    <TeamName team={team} size="large" color={useTeamColor ? team.color : ""}></TeamName>
                </Box>
            </>
        );
    }
};

export const TeamName = ({ team, size, color, border }: { team?: TeamViewModel; size: string; color: string; border?: boolean }) => {
    return team ? (
        <Text size={size} color={color} truncate="tip" style={{ fontWeight: "bold", textTransform: "uppercase", borderBottom: border ? `3px solid ${team.color}` : "" }}>
            {team?.name}
        </Text>
    ) : (
        <></>
    );
};
